import {mapMutations} from "vuex";

export default {
    name: "description",
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    components: {},
    data() {
        return {}
    },
    created() {
    },
    computed: {},
    methods: {
        ...mapMutations({}),
    }
}
